import { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import MAgregarPersona from "@Personal/Modales/MAgregarPersona";
import * as _testing_ from "@Funciones/testing";
import "./Personal.css";

function Personal() {
  const origenComponente = "Personal";
  const { ecv_u, cv_u } = useContext(Contexto);
  const [recargarComponente, erecargarComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    i_procesandoApiCarga: true,
    do_datosTabla: {},
    do_filtros: {},
    do_seleccionados: {},
  });

  useEffect(() => {
    const personaCrud = _api_.f_personasCRUD({
      parametros: { modo: "DSG" },
      timeout: 5000,
    });
    personaCrud.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      if (!dPC.error) {
        console.log(dPC)
        _f_.asignar(ev_u, { do_datosTabla: dPC.contenido });
        console.log(dPC.contenido);
      }
      _f_.asignar(ev_u, { i_procesandoApiCarga: false });
    });
  }, [recargarComponente]);

  useEffect(() => {
    console.log(v_u.do_filtros)
    //console.log(v_u);
    console.log(v_u.do_seleccionados);
  }, [v_u.do_filtros]);

  if (v_u.i_procesandoApiCarga)
    return <_anim_.SpinnerHTML estilos={{ height: "5rem", color: "green" }} />;

  //if (cv_u.error) return <div>error</div>;

  return (
    <div className="personalCSS-contenedor">
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false });
          }}
        >
          <MAgregarPersona
            fCerrarComponente={() => {
              _f_.asignar(ev_c, { modal_mostrar: false });
            }}
            fActualizarTablaTotal={(actualizar) => {
            if (actualizar) {
              erecargarComponente((prev) => {
                return !prev;
              });
            }
          }}
          />
        </ModalInformacion>
      )}

      {
        <Filtros
          titulo={"Personal"}
          filtros={v_u.do_datosTabla.filtros}
          funcionObtenerValores={(valores) => {
            _f_.asignar(ev_u, { do_filtros: valores });
          }}
        />
      }

      <div className="personalCSS-cuerpo">
        <_tabla_.Tabla
          origenComponente={origenComponente}
          cabecera={v_u.do_datosTabla.headgrid}
          registros={v_u.do_datosTabla.grid}
          filtros={v_u.do_filtros}
          permiteMultiseleccion={false}
          permiteOpciones={true}
          camposCodigosSeleccion={["codigo"]}
          fObtenerSeleccionados={(seleccionados) => {
            _f_.asignar(ev_u, { do_seleccionados: seleccionados });
          }}
          mapaDeComponentes={{
            MAgregarPersona,
          }}
          fNotificarActualizacionDeTabla={(actualizar) => {
            if (actualizar) {
              erecargarComponente((prev) => {
                return !prev;
              });
            }
          }}
        />
      </div>

      <div className="personalCSS-opciones">
        <_btn_.Boton
          texto="Agregar Personal"
          tipo="btn-2"
          estilos={{ anchoB2: "10rem", color: "#4e942e" }}
          // procesando={v_u.v_formulario}
          onClick={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "Agregar Persona",
              modal_estilos: { anchoMI: "40rem" },
            });
          }}
        />
      </div>
    </div>
  );
}
export default Personal;
